// This file contains the modal creation logic for SmartInsights
// It creates and manages the modal overlay for QuickSight embedding

import { flashMessages } from 'core/helpers/flash_messages.js';

export function createSmartInsightsModal() {
  try {
    const overlay = document.createElement('div');
    overlay.className = 'smartinsights-q-modal-overlay';

    const modal = document.createElement('div');
    modal.className = 'smartinsights-q-modal-container';

    // modal.style.width = '80%';  // or '1200px' for fixed width
    // modal.style.maxWidth = '1400px';  // Maximum width
    // modal.style.margin = '0 auto';  // Center the modal

    const header = document.createElement('div');
    header.className = 'smartinsights-q-modal-header';

    const closeButton = document.createElement('button');
    closeButton.innerHTML = '✕';
    closeButton.className = 'smartinsights-q-modal-close-button';

    const content = document.createElement('div');

    content.id = 'quicksight-modal-embed';
    content.className = 'smartinsights-q-modal-content';

    const loadingText = document.createElement('div');
    loadingText.textContent = window.translations.loadingMessage;
    loadingText.id = 'quicksight-loading-indicator';
    content.appendChild(loadingText);

    header.appendChild(closeButton);
    modal.appendChild(header);
    modal.appendChild(content);
    overlay.appendChild(modal);
    document.body.appendChild(overlay);

    const closeModal = () => overlay.remove();
    closeButton.onclick = closeModal;
    
    // Prevent clicks on the modal from bubbling up to the overlay
    modal.addEventListener('click', (e) => {
      e.stopPropagation();
    });
    
    // Close modal when clicking on the overlay (grey background)
    overlay.addEventListener('click', closeModal);

    return {
      overlay,
      modal,
      content,
      close: closeModal
    };

  } catch (error) {
    flashMessages.setFlash(window.translations.errorMessage, 'danger');
    return null;
  }
}
// Make function available globally
window.createSmartInsightsModal = createSmartInsightsModal;